/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Art_NoteInputs */

const en_svc_n8n_art_note = /** @type {(inputs: Svc_N8n_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative run log. Your workflows decide the detail.`)
};

const lv_svc_n8n_art_note = /** @type {(inputs: Svc_N8n_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustratīvs izpildes žurnāls. Detaļas nosaka Jūsu darba plūsmas.`)
};

/**
* | output |
* | --- |
* | "Illustrative run log. Your workflows decide the detail." |
*
* @param {Svc_N8n_Art_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_art_note = /** @type {((inputs?: Svc_N8n_Art_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Art_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_art_note(inputs)
	return en_svc_n8n_art_note(inputs)
});